import * as Sentry from '@sentry/react';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import rootReducer from 'store/rootReducer';
import rootSaga from 'store/rootSaga';
// import reduxImmutableStateInvariant from 'redux-immutable-state-invariant'

export default function configureStore() {
  let isProduction = process.env.NODE_ENV === 'production';
  const sagaMiddleware = createSagaMiddleware();
  // const immutableStateMiddleware = reduxImmutableStateInvariant()
  const sentryReduxEnhancer = Sentry.createReduxEnhancer({
    // Optionally pass options listed below
  });
  let middleware = [sagaMiddleware];
  const appliedMiddleWare = applyMiddleware(...middleware);
  const store = createStore(
    rootReducer,
    isProduction
      ? composeWithDevTools(appliedMiddleWare, sentryReduxEnhancer)
      : composeWithDevTools(appliedMiddleWare)
  );
  sagaMiddleware.run(rootSaga);
  return store;
}
